import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { references } from './references'

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss']
})
export class ReferencesComponent implements OnInit {

  selectedReferences: any[];
  selectedReferenceGroupName: any;

  constructor(
    private _activatedRoute: ActivatedRoute
    ) { }

  ngOnInit(): void {

    window.scrollTo(0, 0);

    this.showReferences('morbus-fabry');

    this._activatedRoute.fragment.subscribe(
      (fragments) => {
        var infoSplited = fragments.split("|");
        if(infoSplited.length>1) {
          this.showReferences(infoSplited[0]);
        } else {
          this.showReferences(fragments);
        }
        /* Old */
        /*var s = document.querySelector(".info-section-1");
        s.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});*/

        /* New */
        setTimeout(()=>{
          if(infoSplited.length>1) {
            var id = infoSplited[1];
            if(infoSplited[1]=="Kardiologie") {
              var yOffset = -320;
            }
            if(infoSplited[1]=="Nephrologie") {
              var yOffset = -320;
            }
            if(infoSplited[1]=="Neurologie") {
              var yOffset = -250;
            }
          } else {
            var yOffset = -250;
            var id = 'top';
          }
          const element = document.getElementById(id);
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }, 200);
      }
    ); // update on all changes



  }

  showReferences(newActiveBlock){
    this.selectedReferenceGroupName = newActiveBlock;
    this.selectedReferences = references[this.selectedReferenceGroupName];
  }

}
